import { useBrandAccent } from "@/v2/hooks/useBrandAccent";

/** Renders nothing; keeps the accent CSS variables in step with branding. */
const BrandAccent = () => {
  useBrandAccent();
  return null;
};

export default BrandAccent;
